const assets = {
  payPayLogo: "/paypay_logo_white.png",
  heroImage: "/yofukashi/hero_image.webp",
};

export default assets;
